<template>
    <div>
        <el-row>
            <el-col
                :xs="24"
                :sm="12"
                :lg="8"
                v-for="(value, label) in currentFormCheckItems"
                :key="label"
            >
                <div class="checkbox-item-wrapper">
                    <label>{{ label }}</label>
                    <checkview
                        :label="label"
                        class="check-view"
                        :questions="getAssociatedQuestions(value)"
                        :map="value"
                        @change="onCheckChange"
                    ></checkview>
                </div>
            </el-col>
        </el-row>
        <el-form>
            <el-form-item>
                <template slot="label">
                    <span class="form-label">{{ $t('Generated Remarks') }}</span>
                </template>

                <el-input type="textarea" rows="4" :value="generatedRemarks" readonly />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import FormQuestion from '@/data/FormQuestion';
import checkview from './checkview.vue';

const QUESTION_MAP = {
    'DG Container': {
        Documentation: {
            'Is Shipping Paper/DGD compliant': '2',
        },
        Misdeclared: {},
        'Undeclared DG': {},
        'Structural Serviceability': {
            'Is this container structurally serviceable': '2',
        },
        'CSC Plate': {
            'CSC Plate Valid': '2',
        },
        'Packaging Labels/Marks': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Damage': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Compliance': {
            'Is Packaging acceptable where sighted': [
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        Segregation: {
            'Is Noted Segregation acceptable': '2',
        },
        'Stowage & Securing': {
            'Is Noted Securing acceptable': '2',
            'Is documented mass less than max allowable payload': '2',
        },
        Placards: {},
        'Container Marks': {
            'Marks Correctly Applied': '2',
        },
        'Leaks/Spillage': {
            'Evidence of Leakage/Spillage': '1',
        },
    },
    'Non-DG Container': {
        Documentation: {
            'Is Shipping Paper/DGD compliant': '2',
        },
        Misdeclared: {},
        'Undeclared DG': {},
        'Structural Serviceability': {},
        'CSC Plate': {
            'CSC Plate Valid': '2',
        },
        'Packaging Labels/Marks': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Damage': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Compliance': {
            'Is Packaging acceptable where sighted': [
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        Segregation: {
            'Is Noted Segregation acceptable': '2',
        },
        'Stowage & Securing': {
            'Is Noted Securing acceptable': '2',
            'Is documented mass less than max allowable payload': '2',
        },
        'Leaks/Spillage': {
            'Evidence of Leakage/Spillage': '1',
        },
    },
    'DG Tank': {
        Documentation: {
            'Is Shipping Paper/DGD compliant': '2',
        },
        Misdeclared: {},
        'Undeclared DG': {},
        'Structural Serviceability': {
            'Tank Manufacture Date was': '3',
            'Last Pressure Test Date was': '3',
            'Last Visual Inspection Date was': '3',
            'Does the tank have a Bottom Outlet Valve': '1',
            'Bottom Valves authorized for this commodity': '2',
            'Framework including saddles': '2',
            'Corner Casting': '2',
        },
        'CSC Plate': {
            'CSC Plate Valid': '2',
        },
        'Packaging Labels/Marks': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Damage': {
            'Is Packaging acceptable where sighted': [
                '2', // 'No - Packaging Damaged',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        'Packaging Compliance': {
            'Is Packaging acceptable where sighted': [
                '3', // 'No - Packaging Non-Compliant',
                '4', // 'No - Packaging Damaged and Packaging Non-Compliant'
            ],
        },
        Segregation: {
            'Is Noted Segregation acceptable': '2',
        },
        'Stowage & Securing': {
            'Is Noted Securing acceptable': '2',
            'Is documented mass less than max allowable payload': '2',
        },
        Placards: {
            'Tank properly Placarded (each side/end)': '2',
        },
        'Container Marks': {
            'Tank marked with proper Shipping name (each side)': '2',
            'Tank marked with UN number (each side/end)': '2',
        },
        'Periodic Tank Inspections': {
            'Last Pressure Test Deficient': '1',
            'Last Visual Inspection Deficient': '1',
        },
        'Tank Fixtures': {
            'Compressed Air Connection': '2',
            'Drip Cap (Lower Dis Valve)': '2',
            'Temparature / Pressure / Fill Gauges': '2',
            'Insulation Jacket / Cladding': '2',
            Manhole: '2',
            'Pressure Valves': '2',
            'Remote Emergency Shutoff': '2',
            Tank: '2',
            'Upper/Lower Discharge Valves': '2',
        },
        'Leaks/Spillage': {
            'Evidence of Leakage/Spillage': '1',
        },
    },
};

export default {
    props: {
        form: { type: Object, required: true },
        sections: { type: Array, required: false },
        questions: { type: Array, required: false },
        question: { type: FormQuestion, required: true },
        viewState: { type: Boolean, default: false },
    },
    components: { checkview },
    data() {
        return {
            map: QUESTION_MAP,
            remarks: [],
        };
    },
    computed: {
        currentFormCheckItems() {
            return this.map[this.form.name];
        },
        generatedRemarks() {
            const { remarks } = this;
            let text = null;
            if (remarks.length) {
                text = `${this.generatedDeficiencyComments}\n${remarks.join(', ')}`;
            }

            return text;
        },
        generatedDeficiencyComments() {
            return 'All noted deficiencies corrected during inspection and prior to the issuance of this report.';
        },
    },
    methods: {
        findQuestionByCaption(caption) {
            let question = null;

            if (this.questions.length) {
                this.questions.some((item) => {
                    if (
                        item.caption.toLowerCase().trim().indexOf(caption.toLowerCase().trim()) > -1
                    ) {
                        question = item;
                        return true;
                    }

                    return false;
                });
            }
            if (!question && this.sections.length) {
                this.sections.some((section) => {
                    section.questions.some((item) => {
                        if (
                            item.caption
                                .toLowerCase()
                                .trim()
                                .indexOf(caption.toLowerCase().trim()) > -1
                        ) {
                            question = item;
                            return true;
                        }

                        return false;
                    });

                    return !!question;
                });
            }

            return question;
        },
        getAssociatedQuestions(value) {
            const questions = [];

            Object.keys(value).forEach((questionCaption) => {
                const question = this.findQuestionByCaption(questionCaption);
                if (question) {
                    questions.push(question);
                }
            });

            return questions;
        },
        onCheckChange(checked, checkLabel) {
            if (checked && this.remarks.indexOf(checkLabel) == -1) {
                this.remarks.push(checkLabel);
            } else if (!checked && this.remarks.indexOf(checkLabel) > -1) {
                this.remarks.splice(this.remarks.indexOf(checkLabel), 1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.checkbox-item-wrapper {
    display: flex;
    justify-content: space-between;

    > label {
        flex-shrink: 0;
    }

    .check-view {
        flex-grow: 1;
        margin: 10px !important;
    }
}
</style>
